import Cookies from "js-cookie";
import React, { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import "./App.css";
import Sidebar from "./components/sidebar/Sidebar";
import { Button } from "react-bootstrap";


function PrivateRouter() {
  const navigateTo = useNavigate();
  let accessToken = "logged";
  // return sessionStorage.getItem("argument1") ? (
  return accessToken !== "" ? (
    <>
      {/* <Navigate to="dashboard" /> */}
      <div className="App">
        <div className="MainContainer">
          <Sidebar />
          <Outlet />
         
        </div>
      </div>
    </>
  ) : (
    <Navigate to="login" />
  );
}

export default PrivateRouter;
